import { render, staticRenderFns } from "./MonthFinanceView.vue?vue&type=template&id=2f70af72&scoped=true"
import script from "./MonthFinanceView.vue?vue&type=script&lang=js"
export * from "./MonthFinanceView.vue?vue&type=script&lang=js"
import style0 from "./MonthFinanceView.vue?vue&type=style&index=0&id=2f70af72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f70af72",
  null
  
)

export default component.exports